// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"28c5f29e","52":"a48fc16b","252":"dc9a3c0e","329":"e15d3213","349":"bb076e4a","456":"ee086cd0"}[chunkId] + ".chunk.css";
};